/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_BlogInputs */

const en_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const es_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const de_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const zh_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博客`)
};

const ar_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدونة`)
};

const fr_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const vi_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const sw_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogu`)
};

const th_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บล็อก`)
};

const bs_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const ja_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブログ`)
};

const ko_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`블로그`)
};

const pt_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const it_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const sv_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogg`)
};

const nl_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const da_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const nb_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogg`)
};

const fi_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogi`)
};

const pl_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const ru_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блог`)
};

const tr_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const hi_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्लॉग`)
};

const id_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const ms_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const cs_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const el_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const he_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בלוג`)
};

const af_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const hu_footer_link_blog = /** @type {(inputs: Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Footer_Link_BlogInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_blog = /** @type {((inputs?: Footer_Link_BlogInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_BlogInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_blog(inputs)
	if (locale === "de") return de_footer_link_blog(inputs)
	if (locale === "zh") return zh_footer_link_blog(inputs)
	if (locale === "ar") return ar_footer_link_blog(inputs)
	if (locale === "fr") return fr_footer_link_blog(inputs)
	if (locale === "vi") return vi_footer_link_blog(inputs)
	if (locale === "sw") return sw_footer_link_blog(inputs)
	if (locale === "th") return th_footer_link_blog(inputs)
	if (locale === "bs") return bs_footer_link_blog(inputs)
	if (locale === "ja") return ja_footer_link_blog(inputs)
	if (locale === "ko") return ko_footer_link_blog(inputs)
	if (locale === "pt") return pt_footer_link_blog(inputs)
	if (locale === "it") return it_footer_link_blog(inputs)
	if (locale === "sv") return sv_footer_link_blog(inputs)
	if (locale === "nl") return nl_footer_link_blog(inputs)
	if (locale === "da") return da_footer_link_blog(inputs)
	if (locale === "nb") return nb_footer_link_blog(inputs)
	if (locale === "fi") return fi_footer_link_blog(inputs)
	if (locale === "pl") return pl_footer_link_blog(inputs)
	if (locale === "ru") return ru_footer_link_blog(inputs)
	if (locale === "tr") return tr_footer_link_blog(inputs)
	if (locale === "hi") return hi_footer_link_blog(inputs)
	if (locale === "id") return id_footer_link_blog(inputs)
	if (locale === "ms") return ms_footer_link_blog(inputs)
	if (locale === "cs") return cs_footer_link_blog(inputs)
	if (locale === "el") return el_footer_link_blog(inputs)
	if (locale === "he") return he_footer_link_blog(inputs)
	if (locale === "af") return af_footer_link_blog(inputs)
	if (locale === "hu") return hu_footer_link_blog(inputs)
	return en_footer_link_blog(inputs)
});